<template>
    <div class="modal-slide"
        :class="[className, { 'modal-slide--show': isVisible }]"
    >
        <transition name="fade"
            :duration="duration"
        >
            <div v-show="value"
                class="modal-slide__mask"
                @click="handleClickModal"
            />
        </transition>

        <transition name="slide">
            <div v-show="value"
                class="modal-slide__content"
                :style="contentStyle"
            >
                <div class="slide-content">
                    <div class="slide-title">
                        <span v-if="showTitle">{{ title }}</span>
                        <slot name="title" />
                    </div>
                    <div class="slide-content__inner">
                        <slot />
                    </div>
                    <div class="slide-footer">
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
const DURATION = 300

export default {
    name: 'SlideModal',
    props: {
        value: Boolean,
        title: String,
        closeOnClickModal: {
            type: Boolean,
            default: true,
        },
        className: {
            type: String,
            default: '',
        },
        width: String,
    },
    data() {
        return {
            isVisible: false,
            duration: { enter: DURATION - 100, leave: DURATION + 100 },
        }
    },
    computed: {
        showTitle() {
            return !this.$slots.title && this.title
        },
        contentStyle() {
            const { width } = this
            return width ? {
                width,
            } : null
        },
    },
    watch: {
        value(val) {
            const doc = document.documentElement
            if (val) {
                doc && (doc.style.overflow = 'hidden')
                this.isVisible = val
                this.$emit('open')
            } else {
                doc && (doc.style.overflow = 'auto')
                setTimeout(() => {
                    this.isVisible = val
                    this.$emit('close')
                }, DURATION)
            }
        },
    },
    methods: {
        closeModal() {
            this.$nextTick(() => {
                this.$emit('input', false)
            })
        },
        handleClickModal() {
            if (this.closeOnClickModal) {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="less" scoped>
.responsive(@offset) {
  .modal-slide {
      top: @offset;
  }
}

@media only screen and (min-width: 1600px) {
  .responsive(52px)
}
@media only screen and (max-width: 1600px) {
  .responsive(52px)
}
@media only screen and (max-width: 1366px) {
  .responsive(52px)
}

.modal-slide {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 1000;
  visibility: hidden;
  &.modal-slide--show {
      visibility: visible;
  }
  &__mask {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 1;
      background: rgba(0, 0, 0, 0.3);
  }
  &__content {
      position: absolute;
      width: calc(100% ~'-' 300px);
      height: 100%;
      right: 0;
      z-index: 2;
      overflow: hidden;
      background: #fff;
      border-radius: 2px 0 0 2px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
  .slide {
      position: relative;
      &-title {
          color: #3E4352;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          padding: 16px 24px;
      }
      &-content {
          position: relative;
          width: 100%;
          height: 100%;
          overflow-x: hidden;
          // overflow-y: auto;
          display: flex;
          flex-direction: column;
          &__inner {
              // flex: 1;
              height: 100%;
              overflow-y: auto;
          }
      }
      &-footer {
          width: 100%;
          // position: absolute;
          // bottom: 0;
          // left: 0;
          border-top: 1px solid #F6F7FC;
      }
  }
}

.fade {
  &-enter-active,
  &-leave-active {
      transition: opacity 0.3s;
  }
  &-enter,
  &-leave-to {
      opacity: 0;
  }
  &-leave,
  &-enter-to {
      opacity: 1;
  }
}

.slide {
  &-enter-active,
  &-leave-active {
      transition: transform 0.3s;
      transform: translateZ(0);
  }
  &-enter,
  &-leave-to {
      transform: translate(100%, 0);
  }
  &-leave,
  &-enter-to {
      transform: translate(0, 0);
  }
}
</style>
